import React from 'react';
import styled from 'styled-components';

import P from 'prop-types';

const TransportDetails = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  transition: box-shadow 0.3s ease; /* Adicionando uma transição suave para o efeito hover */

  &:hover {
    cursor: pointer;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 4px 8px, rgba(0, 0, 0, 0.4) 0px 4px 8px; /* Sombras ajustadas no hover */
  }
`;

const TransportNumber = styled.span`
  font-weight: bold;
  margin-right: 10px;
`;

const DriverName = styled.span`
  flex-grow: 1;
  text-align: center;
  margin-right: 10px;
`;

const Status = styled.span`
  color: green;
  text-decoration: underline;
`;

export const CardToken = ({ data }) => {
  const { nTransportadora, motorista } = data;

  return (
    <>
      <TransportDetails className="mb-3">
        <TransportNumber>#{nTransportadora}</TransportNumber>
        <DriverName>{motorista}</DriverName>
        <Status>Em andamento</Status>
      </TransportDetails>
    </>
  );
};

CardToken.propTypes = {
  data: P.shape({
    nTransportadora: P.number,
    motorista: P.string,
  }),
};
